import { ProjectAppFrame } from "~/pages/manifold-nextgen/components/conversations/ProjectAppFrame";
import {
  hasAppManifest,
  HtmlViewer,
  useArtifactHtml,
} from "~/pages/manifold-nextgen/components/conversations/artifacts/HtmlArtifact";
import { type ArtifactPreview } from "~/services/artifacts";

interface ArtifactAppViewProps {
  preview: ArtifactPreview;
  // The project's UUID, which the project apps server takes.
  projectId: string | undefined;
  conversationId: string | null;
  className?: string;
}

/**
 * An HTML artifact opened as an app. A template that declares a manifest runs as
 * a draft of its session's app; plain HTML renders as it does in the chat.
 */
export const ArtifactAppView = ({
  preview,
  projectId,
  conversationId,
  className,
}: ArtifactAppViewProps) => {
  const { html } = useArtifactHtml(preview);

  if (html === undefined || !hasAppManifest(html)) {
    return <HtmlViewer preview={preview} className={className} />;
  }
  if (!projectId || !conversationId || !preview.artifact_name) {
    return (
      <div className="flex h-full items-center justify-center p-6 text-center text-sm text-destructive">
        Apps run inside a project session.
      </div>
    );
  }
  return (
    <ProjectAppFrame
      projectId={projectId}
      slug={preview.artifact_name}
      draftIn={conversationId}
      title={preview.artifact_name}
      version={preview.artifact_id}
      className={className}
    />
  );
};
